import {executeQuery, getSsoAxios, setUser} from "@/main";
import getCofaceWebAssicuratiEndpoint from "raw-loader!./graphQL/query/getCofaceWebAssicuratiEndpoint.graphql";

export default class LoginService {

    getCofaceWebAssicuratiEndpoint(){
        return executeQuery(getCofaceWebAssicuratiEndpoint)
    }
    doLogin(username,password, applicationCode) {
        const data = { username: username, password: password, applicationCode: applicationCode};
        return getSsoAxios()
            .post('authenticate',data)
            .then(result => {
                return result.data;
            }).catch(e => {
                console.log(e)
                setUser(null);
                throw e;
            });
    }
    changePassword(user) {
        return getSsoAxios()
            .post('password-change',user)
            .then(result => {
                return result.data;
            }).catch(e => {
                throw e;
            });
    }
    resetPassword(user) {
        return getSsoAxios()
            .post('password-reset',user)
            .then(result => {
                return result.data;
            }).catch(e => {
                throw e;
            });
    }
    recoverUsername(user) {
        return getSsoAxios()
            .post('recover-username',user)
            .then(result => {
                return result.data;
            }).catch(e => {
                throw e;
            });
    }
}
